/* IN A BOX — guided configurator: Choose → Customise → Pay → Receive.
   Every answer is attached to the order as line-item properties, so production
   sees the whole brief on the Shopify order (not only in emails). */
(function () {
  'use strict';
  var IAB = window.IAB;
  var root = document.querySelector('[data-iab-cfg]');
  var dataEl = document.getElementById('iab-cfg-data');
  if (!IAB || !root || !dataEl) return;

  var D = JSON.parse(dataEl.textContent);
  function opts(list) {
    return (list || []).map(function (l) { l = String(l).trim(); if (!l) return null; var p = l.split('|'); return { name: p[0].trim(), desc: (p[1] || '').trim() }; }).filter(Boolean);
  }
  var STYLES = opts(D.styles), LANGS = opts(D.languages), OBJS = opts(D.objectives), CTAS = opts(D.ctas);
  var KEY = 'iab_cfg_v1';
  var $ = function (s, r) { return (r || root).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };

  /* ---------- state ---------- */
  var S = { box: '', variant: 0, creators: [], styles: [], language: '', objective: '', cta: '', fields: {}, showBox: false, showPkg: false };
  try { var saved = JSON.parse(sessionStorage.getItem(KEY) || 'null'); if (saved) S = Object.assign(S, saved); } catch (e) {}
  var qp = new URLSearchParams(location.search);
  if (qp.get('box') && D.boxes[qp.get('box')]) { if (S.box !== qp.get('box')) { S.box = qp.get('box'); S.variant = 0; S.styles = []; } }
  if (qp.get('v')) {
    var vid = parseInt(qp.get('v'), 10);
    Object.keys(D.boxes).forEach(function (k) { D.boxes[k].variants.forEach(function (v) { if (v.id === vid) { S.box = k; S.variant = vid; } }); });
  }
  if (qp.get('creator')) S.creators = [qp.get('creator').toUpperCase()];
  if (!S.box) S.showBox = true;
  var box = function () { return D.boxes[S.box]; };
  if (S.box && !S.variant && box().variants.length === 1) S.variant = box().variants[0].id;
  if (S.box && !S.variant) S.showPkg = true;
  var cur = 0, started = false, browser = null;

  function save() { try { sessionStorage.setItem(KEY, JSON.stringify(S)); } catch (e) {} }
  function pkgIndex() { var b = box(); if (!b) return 0; for (var i = 0; i < b.variants.length; i++) if (b.variants[i].id === S.variant) return i; return 0; }
  function variant() { var b = box(); return b ? b.variants[pkgIndex()] : null; }
  function maxCreators() { var b = box(); return b ? parseInt(b.creators[pkgIndex()] || b.creators[0] || 1, 10) || 1 : 1; }
  function maxStyles() { var b = box(); return b ? Math.min(parseInt(b.styles[pkgIndex()] || 9, 10) || 9, STYLES.length) : 2; }
  function units() { var b = box(); return b ? b.units[pkgIndex()] || b.units[0] : 0; }
  function isInf() { return box() && box().kind === 'influencer'; }

  function steps() {
    var s = [];
    if (S.showBox || !S.box) s.push('box');
    if (S.box && (S.showPkg || !S.variant) && box().variants.length > 1) s.push('package');
    if (S.box) s = s.concat(['product', 'creator', 'style', 'language', 'objective', 'cta', 'review']);
    return s;
  }

  /* ---------- option renderers ---------- */
  function optHtml(o, attrs, pressed, extra) {
    return '<button type="button" class="iab-opt" ' + attrs + ' aria-pressed="' + (pressed ? 'true' : 'false') + '"><b>' + IAB.esc(o.name) + '</b>' + (o.desc ? '<span>' + IAB.esc(o.desc) + '</span>' : '') + (extra || '') + '</button>';
  }

  function renderBoxes() {
    var cards = [];
    var from = function (b) { var m = Infinity; b.variants.forEach(function (v) { m = Math.min(m, v.price); }); return m === Infinity ? '' : 'From ' + IAB.money(m); };
    if (D.adsPrice) cards.push('<a class="iab-opt iab-opt--box" href="' + IAB.esc(D.adsUrl) + '" style="text-decoration:none"><b>Ads in a Box</b><span>100 static ads for Meta and Instagram. Has its own quick checkout.</span><em>' + IAB.money(D.adsPrice) + '</em></a>');
    var desc = { ugc: 'Pick an AI creator and get vertical UGC video ads.', influencer: 'One AI creator making content for you all month. One-time, no auto-renew.', performance: '100 static ads + 10 UGC videos.', engine: '100 static ads + 25 UGC videos.', test: 'Internal payment test. Walks through the full flow and charges ₹10. Remove before launch.' };
    Object.keys(D.boxes).forEach(function (k) {
      var b = D.boxes[k]; if (!b.variants.length) return;
      cards.push(optHtml({ name: b.label, desc: desc[k] || '' }, 'data-box="' + k + '"', S.box === k, '<em>' + from(b) + (k === 'influencer' ? ' / month' : '') + '</em>'));
    });
    cards.push('<a class="iab-opt iab-opt--box" href="' + D.exclusiveUrl + '" style="text-decoration:none"><b>Exclusive AI Influencer</b><span>A custom creator built only for your brand. Scope agreed before you pay.</span><em>From ₹15,000</em></a>');
    $('[data-cfg-boxes]').innerHTML = cards.join('');
  }

  function renderPackages() {
    var b = box(); if (!b) return;
    $('[data-cfg-pkg-title]').textContent = isInf() ? 'Choose your plan' : 'Choose your package';
    $('[data-cfg-pkg-sub]').textContent = isInf() ? 'One month of content from one AI creator. Nothing renews automatically.' : 'More videos means more hooks and angles to test.';
    $('[data-cfg-packages]').innerHTML = b.variants.map(function (v, i) {
      var hot = !isInf() && b.variants.length === 3 && i === 1;
      var per = Math.round(v.price / (b.units[i] || 1));
      return '<button type="button" class="iab-opt" role="radio" data-variant="' + v.id + '" aria-checked="' + (S.variant === v.id) + '"' + (v.available ? '' : ' aria-disabled="true"') + '>' +
        (hot ? '<span class="iab-badge iab-opt__hot">Most popular</span>' : '') +
        '<b>' + IAB.esc(v.title) + '</b><span>' + IAB.money(per) + ' per video · ' + IAB.esc(b.eta[i] || b.eta[0] || '') + '</span><em>' + IAB.money(v.price) + '</em></button>';
    }).join('');
  }

  function renderStyles() {
    var max = maxStyles();
    $('[data-cfg-style-title]').textContent = isInf() ? 'What kind of content?' : 'What should they make?';
    $('[data-cfg-style-sub]').textContent = max >= STYLES.length - 1 ? 'Choose as many formats as you like, or let us decide.' : 'Your package includes up to ' + max + ' format' + (max > 1 ? 's' : '') + '. Or let us decide.';
    $('[data-cfg-styles]').innerHTML = STYLES.map(function (o) { return optHtml(o, 'data-style="' + IAB.esc(o.name) + '"', S.styles.indexOf(o.name) > -1); }).join('');
  }
  function renderSingle(sel, list, key, otherSel, otherMatch) {
    $(sel).innerHTML = list.map(function (o) { return optHtml(o, 'role="radio" data-' + key + '="' + IAB.esc(o.name) + '"', S[key] === o.name); }).join('');
    $$(sel + ' [role=radio]').forEach(function (b) { b.setAttribute('aria-checked', b.getAttribute('aria-pressed')); });
    if (otherSel) $(otherSel).hidden = !otherMatch(S[key]);
  }
  var isOtherLang = function (v) { return /more/i.test(v || ''); };
  var isOtherObj = function (v) { return /^other$/i.test(v || ''); };
  var isOtherCta = function (v) { return /custom/i.test(v || ''); };

  /* ---------- fields ---------- */
  function bindFields() {
    $$('[data-cfg-field]').forEach(function (el) {
      var k = el.getAttribute('data-cfg-field');
      if (S.fields[k] != null) el.value = S.fields[k];
      el.addEventListener('input', function () {
        S.fields[k] = el.value; save(); renderSummary();
        if (!started && steps()[cur] === 'product') { started = true; IAB.track('brief_started', { box: S.box }); }
      });
    });
    var ind = $('[data-cfg-field=industry]');
    if (ind) { ind.innerHTML = '<option value="">Choose…</option>' + (D.industries || []).map(function (i) { i = i.trim(); return '<option' + (S.fields.industry === i ? ' selected' : '') + '>' + IAB.esc(i) + '</option>'; }).join(''); ind.addEventListener('change', function () { S.fields.industry = ind.value; save(); }); }
    var logo = $('[data-cfg-logo]');
    if (logo) logo.addEventListener('change', function () {
      var f = logo.files[0];
      if (f && f.size > 20 * 1024 * 1024) { IAB.toast('That file is over 20 MB. Use the asset link instead.'); logo.value = ''; return; }
      $('[data-cfg-logo-name]').textContent = f ? f.name : 'Upload PNG, SVG or JPG';
    });
    var an = $('[data-cfg-analyze]');
    if (an && D.analyzeEndpoint) an.addEventListener('click', analyze);
  }

  function analyze() {
    var url = normUrl(S.fields.url);
    if (!url) { err('url', 'Paste your product link first.'); return; }
    var btn = $('[data-cfg-analyze]'); btn.disabled = true; btn.innerHTML = '<span class="iab-spin"></span> Analyzing…';
    fetch(D.analyzeEndpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ url: url }) })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (d) {
        ['brand', 'productName', 'industry', 'target', 'offer'].forEach(function (k) {
          if (d[k] && !S.fields[k]) { S.fields[k] = d[k]; var el = $('[data-cfg-field=' + k + ']'); if (el) el.value = d[k]; }
        });
        $('[data-cfg-more]').open = true; save(); IAB.track('product_analyzed', {});
      })
      .catch(function () { IAB.toast('We couldn\'t read that page. Fill in the details below instead.'); })
      .then(function () { btn.disabled = false; btn.textContent = 'Analyze Product →'; });
  }

  function normUrl(u) {
    u = (u || '').trim(); if (!u) return '';
    if (!/^https?:\/\//i.test(u)) u = 'https://' + u;
    return /^https?:\/\/[^\s.]+\.[^\s]{2,}/i.test(u) ? u : '';
  }
  function err(k, msg) { var e = $('[data-cfg-err="' + k + '"]'); if (e) e.textContent = msg || ''; var f = $('[data-cfg-field="' + k + '"]'); if (f) f.setAttribute('aria-invalid', msg ? 'true' : 'false'); if (msg && f) f.focus(); }

  /* ---------- creator step ---------- */
  function initBrowser() {
    var el = document.getElementById('iab-pick');
    if (!el || browser) return;
    browser = new IAB.Browser(el, {
      mode: 'select', kind: isInf() ? 'influencer' : 'ugc', max: maxCreators(),
      onReady: function () {
        var keep = S.creators.slice(); S.creators = [];
        keep.forEach(function (id) { if (browser.byId(id)) browser.pick(id, true); });
        if (keep.length && !S.creators.length) IAB.toast('That creator isn\'t available right now. Please pick another.');
        if (S.fields.industry && !S.creators.length) browser.setFilter('industry', [S.fields.industry]);
      },
      onChange: function (list) { S.creators = list.map(function (c) { return c.id; }); S._names = list.map(function (c) { return c.name; }); S._imgs = list.map(function (c) { return c.image; }); save(); renderSummary(); }
    });
    var f = $('[data-cfg-finder]');
    f.innerHTML = '<div data-endpoint="' + IAB.esc(D.recommendEndpoint || '') + '"><form novalidate><div class="iab-2col">' +
      '<label class="iab-field"><span>Product URL</span><input class="iab-input" type="url" name="url" value="' + IAB.esc(S.fields.url || '') + '"></label>' +
      '<label class="iab-field"><span>Industry</span><select class="iab-select" name="industry"><option value="">Choose…</option>' + (D.industries || []).map(function (i) { i = i.trim(); return '<option' + (S.fields.industry === i ? ' selected' : '') + '>' + IAB.esc(i) + '</option>'; }).join('') + '</select></label></div>' +
      '<button class="iab-btn iab-btn--sm" type="submit">Find My Creator ✨</button><p class="iab-small iab-mt-s" data-find-msg aria-live="polite">' + (D.recommendEndpoint ? 'AI will suggest 3–5 creators for your product.' : 'AI matching is coming soon. For now we\'ll filter by your industry.') + '</p></form></div>';
    new IAB.Finder(f.firstChild, browser, { recs: $('[data-cfg-recs]') });
  }

  /* ---------- summary ---------- */
  function rows() {
    var b = box(), v = variant(), r = [];
    if (!b) return r;
    r.push(['Package', v ? v.title : '—', 'package']);
    if (S.fields.productName || S.fields.url) r.push(['Product', S.fields.productName || S.fields.url, 'product']);
    if (S.fields.brand) r.push(['Brand', S.fields.brand, 'product']);
    if (S.creators.length) r.push(['Creator', S.creators.map(function (id, i) { return id + ' — ' + ((S._names || [])[i] || ''); }).join(', '), 'creator']);
    if (S.language) r.push(['Language', isOtherLang(S.language) ? (S.fields.langOther || 'Other') : S.language, 'language']);
    if (S.styles.length) r.push([isInf() ? 'Content' : 'Creative types', S.styles.join(' + '), 'style']);
    if (S.objective) r.push(['Objective', isOtherObj(S.objective) ? (S.fields.objOther || 'Other') : S.objective, 'objective']);
    if (S.cta) r.push(['CTA', isOtherCta(S.cta) ? (S.fields.ctaOther || 'Custom') : S.cta, 'cta']);
    return r;
  }
  function renderSummary() {
    var b = box(), v = variant();
    var sum = $('[data-cfg-summary]');
    sum.hidden = !b;
    if (!b) { $('[data-cfg-bar-price]').textContent = '—'; $('[data-cfg-bar-label]').textContent = 'Choose a box'; return; }
    var title = isInf() ? 'Your Influencer Box' : (b.bundle ? 'Your ' + b.label : 'Your UGC Box');
    $('[data-cfg-sum-title]').textContent = title;
    var face = S._imgs && S._imgs[0] ? '<span class="iab-summary__face"><img src="' + IAB.esc(S._imgs[0]) + '" alt="">' : '';
    $('[data-cfg-sum]').innerHTML = rows().map(function (r) {
      var val = IAB.esc(r[1]);
      if (r[0] === 'Creator' && face) val = face + '<span>' + val + '</span></span>';
      return '<div><dt>' + r[0] + '</dt><dd>' + val + '</dd></div>';
    }).join('');
    var price = v ? IAB.money(v.price) : '—';
    $('[data-cfg-sum-price]').textContent = price;
    $('[data-cfg-bar-price]').textContent = price;
    $('[data-cfg-bar-label]').textContent = b.label + (v ? ' · ' + v.title : '');
  }
  function renderReview() {
    var b = box(), v = variant();
    $('[data-cfg-review-title]').textContent = isInf() ? 'Your Influencer Box' : (b.bundle ? 'Your ' + b.label : 'Your UGC Box');
    $('[data-cfg-review-name]').textContent = b.label;
    var rr = rows();
    rr.splice(1, 0, ['Includes', units() + ' ' + b.unit, null]);
    $('[data-cfg-review]').innerHTML = rr.map(function (r) {
      return '<div><dt>' + r[0] + '</dt><dd>' + IAB.esc(r[1]) + (r[2] ? '<button type="button" data-goto="' + r[2] + '">Change</button>' : '') + '</dd></div>';
    }).join('');
    $('[data-cfg-review-price]').textContent = v ? IAB.money(v.price) : '—';
    var tot = $('.iab-review__total');
    if (tot && !$('[data-cfg-only]')) tot.insertAdjacentHTML('afterend', '<p class="iab-small iab-muted" data-cfg-only style="margin:0;padding:12px 20px 16px">This is the only item in your order. You pay exactly this amount at checkout: nothing else is added, and nothing renews.</p>');
    var eta = b.eta[pkgIndex()] || b.eta[0] || '';
    $('[data-cfg-eta]').textContent = 'Delivery: ' + eta + '. After checkout you\'ll get a confirmation email. If anything is missing we\'ll email you, and the clock waits until we have it.';
  }

  /* ---------- navigation ---------- */
  function show(i) {
    var st = steps();
    cur = Math.max(0, Math.min(i, st.length - 1));
    var name = st[cur];
    $$('[data-step]').forEach(function (p) { p.hidden = p.getAttribute('data-step') !== name; });
    $('[data-cfg-progress]').innerHTML = st.map(function (_, j) { return '<i class="' + (j < cur ? 'is-done' : j === cur ? 'is-now' : '') + '"></i>'; }).join('');
    $('[data-cfg-stepcount]').textContent = 'Step ' + (cur + 1) + ' of ' + st.length;
    $('[data-cfg-back]').hidden = cur === 0;
    var last = name === 'review';
    $$('[data-cfg-next]').forEach(function (b) { b.innerHTML = last ? 'Pay ' + (variant() ? IAB.money(variant().price) : '') + ' at checkout <span class="iab-arrow" aria-hidden="true">→</span>' : 'Continue <span class="iab-arrow" aria-hidden="true">→</span>'; b.hidden = name === 'box'; });
    if (name === 'box') renderBoxes();
    if (name === 'package') renderPackages();
    if (name === 'creator') {
      initBrowser(); browser.setMax(maxCreators());
      $('[data-cfg-creator-sub]').textContent = (maxCreators() > 1 ? 'Pick up to ' + maxCreators() + ' creators.' : 'Pick the face of your ' + (isInf() ? 'brand.' : 'ads.')) + ' All creators are AI-generated.';
    }
    if (name === 'style') renderStyles();
    if (name === 'language') renderSingle('[data-cfg-langs]', LANGS, 'language', '[data-cfg-lang-other]', isOtherLang);
    if (name === 'objective') renderSingle('[data-cfg-objs]', OBJS, 'objective', '[data-cfg-obj-other]', isOtherObj);
    if (name === 'cta') renderSingle('[data-cfg-ctas]', CTAS, 'cta', '[data-cfg-cta-other]', isOtherCta);
    if (name === 'review') { renderReview(); IAB.track('brief_completed', { box: S.box, variant: S.variant, value: variant() ? variant().price / 100 : 0 }); }
    renderSummary();
    IAB.track('configurator_step', { step: name, index: cur + 1, box: S.box });
    var top = root.getBoundingClientRect().top + window.scrollY - 80;
    if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
  }

  function validate(name) {
    switch (name) {
      case 'package': if (!S.variant) { IAB.toast('Choose a package to continue.'); return false; } return true;
      case 'product':
        var u = normUrl(S.fields.url);
        if (!u) { err('url', 'Add a valid link to your product or brand page.'); return false; }
        S.fields.url = u; var el = $('[data-cfg-field=url]'); if (el) el.value = u; err('url', ''); save(); return true;
      case 'creator': if (!S.creators.length) { IAB.toast('Pick a creator to continue.'); return false; } return true;
      case 'style': if (!S.styles.length) { IAB.toast('Choose at least one format, or pick Surprise Me.'); return false; } return true;
      case 'language':
        if (!S.language) { IAB.toast('Choose a language.'); return false; }
        if (isOtherLang(S.language) && !(S.fields.langOther || '').trim()) { IAB.toast('Tell us which language.'); return false; } return true;
      case 'objective':
        if (!S.objective) { IAB.toast('Choose a goal.'); return false; }
        if (isOtherObj(S.objective) && !(S.fields.objOther || '').trim()) { IAB.toast('Tell us the goal.'); return false; } return true;
      case 'cta':
        if (!S.cta) { IAB.toast('Choose a call to action.'); return false; }
        if (isOtherCta(S.cta) && !(S.fields.ctaOther || '').trim()) { IAB.toast('Write your CTA.'); return false; } return true;
      case 'review':
        if (!$('[data-cfg-ack]').checked) { $('[data-cfg-err="ack"]').textContent = 'Please confirm you understand the creators are AI-generated.'; return false; }
        $('[data-cfg-err="ack"]').textContent = ''; return true;
    }
    return true;
  }

  function next() {
    var st = steps(), name = st[cur];
    if (!validate(name)) return;
    if (name === 'review') return checkout();
    var target = st[cur + 1];
    if (name === 'package') S.showPkg = false;
    save();
    var ns = steps();
    var idx = ns.indexOf(target);
    show(idx < 0 ? cur + 1 : idx);
  }

  /* ---------- checkout ---------- */
  function checkout() {
    var b = box(), v = variant();
    if (!v) return;
    var btns = $$('[data-cfg-next]');
    btns.forEach(function (x) { x.disabled = true; x.innerHTML = '<span class="iab-spin"></span> Preparing checkout…'; });
    var fd = new FormData();
    fd.append('id', v.id);
    fd.append('quantity', '1');
    var P = function (k, val) { if (val != null && String(val).trim() !== '') fd.append('properties[' + k + ']', String(val).trim()); };
    P('Package', v.title);
    P('Deliverable', units() + ' ' + b.unit);
    P('Product URL', S.fields.url);
    P('Brand', S.fields.brand);
    P('Product', S.fields.productName);
    P('Industry', S.fields.industry);
    P('Target customer', S.fields.target);
    P('Offer', S.fields.offer);
    P('Brand colours', S.fields.colours);
    P('Asset link', S.fields.assets);
    P('Creator ID', S.creators.join(', '));
    P('Creator name', (S._names || []).join(', '));
    P(isInf() ? 'Content types' : 'UGC styles', S.styles.join(', '));
    P('Language', isOtherLang(S.language) ? 'Other: ' + (S.fields.langOther || '') : S.language);
    P('Objective', isOtherObj(S.objective) ? 'Other: ' + (S.fields.objOther || '') : S.objective);
    P('CTA', isOtherCta(S.cta) ? 'Custom: ' + (S.fields.ctaOther || '') : S.cta);
    P('Notes', S.fields.notes);
    P('Turnaround', b.eta[pkgIndex()] || b.eta[0]);
    P('_iab_flow', S.box);
    P('_ai_ack', 'yes');
    var logo = $('[data-cfg-logo]');
    if (logo && logo.files && logo.files[0]) fd.append('properties[Logo]', logo.files[0]);

    IAB.track('begin_checkout', { box: S.box, variant: v.id, value: v.price / 100, currency: 'INR', creators: S.creators });
    /* One order = exactly the box the customer just configured. Empty the cart first so nothing
       left over from an earlier visit (or a second pass through this flow) gets charged too. */
    fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .catch(function () {})
      .then(function () {
        return fetch('/cart/add.js', { method: 'POST', body: fd, credentials: 'same-origin', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } });
      })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        IAB.track('add_to_cart', { box: S.box, variant: v.id, value: v.price / 100, currency: 'INR' });
        try { sessionStorage.removeItem(KEY); } catch (e) {}
        location.href = '/checkout';
      })
      .catch(function (e) {
        btns.forEach(function (x) { x.disabled = false; x.innerHTML = 'Pay ' + IAB.money(v.price) + ' at checkout <span class="iab-arrow" aria-hidden="true">→</span>'; });
        IAB.toast((e && (e.description || e.message)) || 'Something went wrong. Please try again.', 4000);
      });
  }

  /* ---------- events ---------- */
  root.addEventListener('click', function (e) {
    var t;
    if ((t = e.target.closest('[data-cfg-next]'))) return next();
    if ((t = e.target.closest('[data-cfg-back]'))) return show(cur - 1);
    if ((t = e.target.closest('[data-box]'))) {
      var k = t.getAttribute('data-box');
      if (S.box !== k) { S.box = k; S.variant = D.boxes[k].variants.length === 1 ? D.boxes[k].variants[0].id : 0; S.styles = []; }
      S.showBox = false; S.showPkg = !S.variant; save();
      IAB.track('box_selected', { box: k });
      return show(0);
    }
    if ((t = e.target.closest('[data-variant]'))) {
      if (t.getAttribute('aria-disabled') === 'true') return;
      S.variant = parseInt(t.getAttribute('data-variant'), 10);
      var mx = maxStyles(); if (S.styles.length > mx) S.styles = S.styles.slice(0, mx);
      save(); renderPackages(); renderSummary();
      IAB.track('package_selected', { box: S.box, variant: S.variant, value: variant().price / 100 });
      return;
    }
    if ((t = e.target.closest('[data-style]'))) {
      var n = t.getAttribute('data-style'), surprise = /surprise/i.test(n), i = S.styles.indexOf(n);
      if (i > -1) S.styles.splice(i, 1);
      else if (surprise) S.styles = [n];
      else {
        S.styles = S.styles.filter(function (x) { return !/surprise/i.test(x); });
        if (S.styles.length >= maxStyles()) { IAB.toast('Your package includes up to ' + maxStyles() + ' formats.'); return; }
        S.styles.push(n);
      }
      save(); renderStyles(); renderSummary(); return;
    }
    if ((t = e.target.closest('[data-language]'))) { S.language = t.getAttribute('data-language'); save(); renderSingle('[data-cfg-langs]', LANGS, 'language', '[data-cfg-lang-other]', isOtherLang); renderSummary(); return; }
    if ((t = e.target.closest('[data-objective]'))) { S.objective = t.getAttribute('data-objective'); save(); renderSingle('[data-cfg-objs]', OBJS, 'objective', '[data-cfg-obj-other]', isOtherObj); renderSummary(); return; }
    if ((t = e.target.closest('[data-cta]'))) { S.cta = t.getAttribute('data-cta'); save(); renderSingle('[data-cfg-ctas]', CTAS, 'cta', '[data-cfg-cta-other]', isOtherCta); renderSummary(); return; }
    if ((t = e.target.closest('[data-goto]'))) {
      var g = t.getAttribute('data-goto');
      if (g === 'package') S.showPkg = true;
      var ix = steps().indexOf(g); if (ix > -1) show(ix); return;
    }
  });
  // the fixed mobile bar sits outside panels but inside root; Enter in inputs advances
  root.addEventListener('keydown', function (e) { if (e.key === 'Enter' && e.target.matches('input[data-cfg-field]')) { e.preventDefault(); next(); } });

  bindFields();
  show(0);
})();
